import { Form, field } from "lib/form";

import { Correction, EntityType } from "../models";

export default class BlockForm extends Form {
  @field("Corrections") public corrections: Correction[] = [];

  @field("Entities") public entities: EntityType[] = [];

  @field("Category") public category: string[];

  @field("Feedback") public feedback: string;
}
